export default {
  "user": {
    "personal-center": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Personal Center"])},
    "control": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Access Control"])},
    "setting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])},
    "subAccount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subaccount"])}
  },
  "feedback": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feedback"])},
  "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Help"])},
  "messages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages"])},
  "count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message count"])}
}